import _extends from "@babel/runtime/helpers/extends";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import CountryFlag from "../../../../components/CountryFlag";
import Select from "../../../../components/Select";
import styles from "./SelectCountry.module.css"; // eslint-disable-next-line

const formatOptionLabel = _ref => {
  let {
    code,
    label
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.selectOption
  }, /*#__PURE__*/React.createElement(CountryFlag, {
    code: code
  }), /*#__PURE__*/React.createElement("span", null, label));
};

const SelectCountry = props => {
  const {
    countries,
    className,
    withShadow,
    borderRadius,
    isRtl,
    isCountrySelectFocused,
    ...otherProps
  } = props;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Select, _extends({
    options: countries,
    className: cx({
      [styles.withShadow]: withShadow
    }, className),
    isRtl: isRtl,
    label: t("Country of destination"),
    styles: {
      control: base => ({ ...base,
        ...Select.baseStyles.control,
        borderRadius
      })
    },
    formatOptionLabel: formatOptionLabel,
    getOptionValue: _ref2 => {
      let {
        code
      } = _ref2;
      return code;
    }
  }, otherProps));
};

__signature__(SelectCountry, "useTranslation{{ t }}", () => [useTranslation]);

SelectCountry.propTypes = {
  className: PropTypes.string,
  borderRadius: PropTypes.string.isRequired,
  withShadow: PropTypes.bool,
  isRtl: PropTypes.bool,
  countries: PropTypes.array,
  isCountrySelectFocused: PropTypes.bool
};
SelectCountry.defaultProps = {
  className: null,
  withShadow: false,
  isRtl: false,
  isCountrySelectFocused: false,
  countries: []
};

const _default = /*#__PURE__*/React.memo(SelectCountry);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(formatOptionLabel, "formatOptionLabel", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/components/SelectCountry/SelectCountry.jsx");
  reactHotLoader.register(SelectCountry, "SelectCountry", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/components/SelectCountry/SelectCountry.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Search/components/SelectCountry/SelectCountry.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();